<div class="feed-content" [ngStyle]="{background: feed?.thumbnailUrl}">
  <video-player [src]="feed?.url" [style]="style" (click)="onLikeClick()" (onPlay)="onPlay()" [poster]="feed?.thumbnailUrl"></video-player>@if (playLikeAnimation) {
  <i class="cs-icon-favorite"></i>
}
</div>